import { addons } from '@storybook/manager-api';
import eloomiTheme from './eloomi-theme';

addons.setConfig({
    theme: eloomiTheme,
});
